export enum ReportStatuses {
  NEW = 'NEW',
  AGREEMENT_LOADED = 'AGREEMENT_LOADED',
  WORK_DONE = 'WORK_DONE',
  PAID = 'PAID',
  CANCELLED = 'CANCELED',
}
